import { Sponsor } from "lib/types/datoBlocks";
import Image from "components/imageNew/image";

type SponsorImageProps = Sponsor;

const SponsorImage = ({ sponsorName, logo }: SponsorImageProps) => {
  return (
    <div className={"mx-2 flex h-[48px] w-[120px] items-center"}>
      <Image
        src={logo.url}
        alt={sponsorName || ""}
        width={logo.width}
        height={logo.height}
        className={"pointer-events-none h-100 w-100 object-contain"}
        blurDataURL={logo.blurUpThumb}
        quality={75}
        sizes={"120px"}
        blurUp={false}
        priority={true}
      />
    </div>
  );
};

export default SponsorImage;
